import type { AdminFeedback } from '../firebase';

export const REASON_LABELS: Record<string, string> = {
  bug: 'Algo no funciona',
  data_error: 'Error en los datos de un informe',
  missing_feature: 'Falta algo / propuesta',
  improvement: 'Sugerencia de mejora',
  billing: 'Pagos o créditos',
  other: 'Otro',
};

export const STATUS_LABELS: Record<string, string> = {
  new: 'Nuevo',
  seen: 'Visto',
  resolved: 'Resuelto',
};

export interface FeedbackFilters {
  status: string; // 'all' | FeedbackStatus
  reason: string; // 'all' | FeedbackReason
  query: string;
}

export function filterFeedback(rows: AdminFeedback[], f: FeedbackFilters): AdminFeedback[] {
  const q = f.query.trim().toLowerCase();
  return rows.filter((r) => {
    if (f.status !== 'all' && r.status !== f.status) {
      return false;
    }
    if (f.reason !== 'all' && r.reason !== f.reason) {
      return false;
    }
    if (q.length === 0) {
      return true;
    }
    const email = (r.email ?? '').toLowerCase();
    return email.includes(q) || r.uid.toLowerCase().includes(q) || r.message.toLowerCase().includes(q);
  });
}
